<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

const props = defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});
const meta = NODE_TYPES.identify_intent;
const intents = computed(() => props.data.intents || []);
const handleTop = index => `${30 + ((index + 1) / (intents.value.length + 2)) * 55}%`;
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p class="text-n-slate-9">Lê a mensagem do cliente e decide a categoria com IA.</p>

    <div
      v-for="(intent, index) in intents"
      :key="index"
      class="flex items-center justify-between gap-2 mt-1 text-[11px] text-n-slate-10"
    >
      <span class="truncate">{{ intent.label || '(sem texto)' }}</span>
      <Handle
        :id="`intent_${index}`"
        type="source"
        :position="Position.Right"
        :style="{ top: handleTop(index) }"
      />
    </div>

    <div class="flex items-center justify-between mt-2 pt-1 border-t border-n-weak text-[11px]">
      <span class="text-n-slate-9">Não identificado</span>
      <Handle type="source" :position="Position.Bottom" />
    </div>
  </FlowNodeCard>
</template>
